'use strict'


define [], () ->
  ($uibModal, $http, $q, $rootScope, $timeout, $state, $resource, $cacheFactory, Landlord, User, ApplicationTemplate) ->
    beginExperianVerificationModal = () ->
      $uibModal.open
        size: 'lg'
        resolve:
          context: () -> experian.context
          pid_data: () -> {}
        template: require("./beginExperianVerification/beginExperianVerification.jade")
        controller: require("./beginExperianVerification/beginExperianVerification.coffee")
      .result

    questionsModal = (all_questions_and_answers) ->
      $uibModal.open
        size: 'lg'
        resolve:
          context: () -> experian.context
          all_questions_and_answers: () -> all_questions_and_answers
        template: require("./experianQuestions/experianQuestions.jade")
        controller: require("./experianQuestions/experianQuestions.coffee")
      .result

    successModal = () ->
      $uibModal.open
        size: 'lg'
        template: require("./success/success.jade")
        controller: require("./success/success.coffee")
      .result

    failureModal = () ->
      $uibModal.open
        size: 'lg'
        windowClass: "warning"
        template: require("./failure/failure.jade")
        controller: require("./failure/failure.coffee")
      .result

    experian =
      beginExperianVerification: () ->
        experian.context = "landlord"
        beginExperianVerificationModal()
        .then questionsModal
        .then successModal
        .then ->
          $cacheFactory.get('$http').removeAll()
          $state.go $state.current.name, $state.params, reload: true
        .catch (reason) ->
          if reason == "failure"
            failureModal()

    experian



// WEBPACK FOOTER //
// ./services/experian/experian.coffee